import type { LoyaltyTier, ProgramSettings } from '../../types/settings';

export function validateProgramSettings(program: ProgramSettings, tiers: readonly LoyaltyTier[]): string | null {
  if (!program.programName.trim()) return 'Program name cannot be empty.';
  if (!Number.isFinite(program.pointsPerCurrency) || program.pointsPerCurrency <= 0) {
    return 'Points per currency must be a positive number.';
  }
  if (!Number.isSafeInteger(program.signupBonus) || program.signupBonus < 0) {
    return 'Signup bonus must be zero or a positive whole number.';
  }
  if (tiers.length === 0 || !tiers.some((tier) => tier.name === program.defaultTier)) {
    return 'Choose a default tier from the configured tiers.';
  }
  if (tiers.some((tier) => !Number.isSafeInteger(tier.minPoints) || tier.minPoints < 0)) {
    return 'Tier point thresholds must be non-negative whole numbers.';
  }
  if (tiers.some((tier) => !Number.isSafeInteger(tier.sortOrder))
    || new Set(tiers.map((tier) => tier.sortOrder)).size !== tiers.length) {
    return 'Each tier must have a unique whole-number display order.';
  }
  const orderedTiers = [...tiers].sort((left, right) => left.sortOrder - right.sortOrder);
  for (let index = 1; index < orderedTiers.length; index += 1) {
    if (orderedTiers[index].minPoints <= orderedTiers[index - 1].minPoints) {
      return 'Tier point thresholds must be strictly increasing.';
    }
  }
  return null;
}
